import React from 'react';

import styled from 'styled-components';

import { ReviewsSummaryInsightItem } from './types';

const Card = styled.div`
  padding: 15px 20px;
  border-radius: 8px;
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
`;

const CardTitle = styled.div`
  font-size: 14px;
  color: var(--text-primary);
  font-family: var(--font-bold);
`;

const CardText = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.5;
`;

const UniqueBadge = styled.span`
  display: inline-block;
  font-size: 8px;
  font-family: var(--font-bold);
  background: white;
  border-radius: 4px;
  padding: 2px 5px;
  color: var(--positive-green);

  &.weakness {
    color: var(--inactive-orange);
  }
`;

const InsightCard = ({
  item,
  index,
  type,
  isUnique,
}: {
  item: ReviewsSummaryInsightItem;
  index: number;
  type: 'strengths' | 'weaknesses';
  isUnique: boolean;
}) => {
  const isStrength = type === 'strengths';
  const background = isStrength ? 'rgba(47, 225, 94, 0.1)' : 'rgba(224, 221, 76, 0.1)';
  return (
    <Card
      key={`${type}-${index}`}
      style={{ background }}
      data-testid={`rs-widget-${type}-item-${index}`}
    >
      <CardHeader>
        <CardTitle data-testid={`rs-widget-${type}-item-${index}-title`}>
          {item.title}
        </CardTitle>
        {isUnique && <UniqueBadge className={isStrength ? 'strength' : 'weakness'}>UNIQUE</UniqueBadge>}
      </CardHeader>
      <CardText data-testid={`rs-widget-${type}-item-${index}-description`}>
        {item.description}
      </CardText>
    </Card>
  );
};

export default InsightCard;
